/**
 * Five Column Layout Component
 *
 * Handles accordion functionality for mobile view with the credit range element as the toggle
 */

const vFiveCol = () => {
	const accordionToggles = document.querySelectorAll( '.v-five-col__accordion-toggle' );

	if ( accordionToggles.length === 0 ) {
		return;
	}

	/**
	 * Toggle accordion content visibility
	 *
	 * @param {Event} e click event
	 */
	const toggleAccordion = ( e ) => {
		const toggle = e.currentTarget;
		const content = toggle.nextElementSibling;
		const isExpanded = toggle.getAttribute( 'aria-expanded' ) === 'true';

		// Only activate on mobile screens
		if ( window.innerWidth > 768 ) {
			return;
		}

		// Toggle active class and aria-expanded
		toggle.classList.toggle( 'active' );
		toggle.setAttribute( 'aria-expanded', !isExpanded );

		// Toggle content visibility
		content.classList.toggle( 'active' );
	};

	// Add click listeners to accordion toggles
	accordionToggles.forEach( ( toggle ) => {
		toggle.addEventListener( 'click', toggleAccordion );
	} );

	// Check on resize to properly reset states when switching between mobile and desktop
	window.addEventListener( 'resize', () => {
		if ( window.innerWidth > 768 ) {
			// Reset all accordions when returning to desktop view
			accordionToggles.forEach( ( toggle ) => {
				const content = toggle.nextElementSibling;
				toggle.classList.remove( 'active' );
				toggle.setAttribute( 'aria-expanded', false );
				content.classList.remove( 'active' );
			} );
		}
	} );
};

export default vFiveCol;
